/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    status: PropTypes.oneOf([
        'standard',
        'valid',
        'error',
    ]).isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    status: 'standard',
};

const FormInfo = (props) => {
    const classNames = [
        'c-form-info',
        props.status === 'valid' ? 'c-form-info--valid' : '',
        props.status === 'error' ? 'c-form-info--error' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

FormInfo.propTypes = propTypes;

FormInfo.defaultProps = defaultProps;

export default FormInfo;
